import { Box, Grid, Paper, Typography, LinearProgress, Icon, IconButton, useTheme, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, Button, Dialog, DialogTitle, DialogContent, CircularProgress, DialogActions, List, ListItem, ListItemButton, Checkbox, ListItemIcon, ListItemText, TextField, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, FormGroup, Switch } from "@mui/material";
import { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import styled from '@emotion/styled';

import { FormHandles } from "@unform/core";
// import { Form } from "@unform/web";
import * as yup from 'yup';

import { AlertSnackBar, FerramentaDeDetalhe } from "../../shared/components"
import { useVForm, VForm, VTextField } from "../../shared/forms";
import { LayoutBaseDePagina } from "../../shared/layouts"
import { ITemp, TipoService } from "../../shared/services/api/tipo/TipoService";
import { ITipo_Indice, Tipo_Indice_Service } from "../../shared/services/api/tipo_indice/Tipo_Indice_Service";
import { IIndice } from "../../shared/services/api/indice/IndiceService";
import { Environment } from "../../shared/environment";
import React from "react";

import { useAppThemeContext } from '../../shared/contexts';

interface IFormDataEditar {
    idTipo: number,
    nomeTipo: string,
}

type Nullable<T> = T | null;

const formValidationSchema: yup.SchemaOf<Omit<IFormDataEditar, 'idTipo'>> = yup.object().shape({
    nomeTipo: yup.string().required('Nome do tipo é obrigatório'),
});

export const DetalheDeTipo: React.FC = () => {
    const { editarOuNovo } = useParams<'editarOuNovo'>();
    const { idTipo } = useParams<'idTipo'>();
    const { nomeTipo } = useParams<'nomeTipo'>();
    const { nivelUrl } = useParams<'nivelUrl'>();
    const nivel = Number(nivelUrl) + 1;
    const { idSetor } = useParams<'idSetor'>();
    const navigate = useNavigate();
    const theme = useTheme();

    const { themeName } = useAppThemeContext();

    const novo = (editarOuNovo === "novo");
    const editar = (editarOuNovo === "editar");

    if (editarOuNovo !== "editar" && editarOuNovo !== "novo") {
        navigate("/");
    }

    const [alert, setAlert] = useState<{ tipoAlert: string, mensagem: string } | undefined>(undefined);
    const [duracaoAlert, setDuracaoAlert] = useState<number>(Environment.DURACAO_ALERT + 500);

    const [isLoading, setIsLoading] = useState(false);
    const [nome, setNome] = useState('');

    const [componente, setComponente] = useState(0);
    const [mascara, setMascara] = useState<string | undefined>();

    const { formRef, save, saveAndReturn, isSaveAndReturn } = useVForm();


    useEffect(() => {
        if (editar) {
            setIsLoading(true);
            setNome("Carregando...")


            TipoService.getById(Number(idTipo)).then((result) => {
                setIsLoading(false);
                if (result instanceof Error) {
                    // se der erro, volta para a listagem para não ficar uma tela em branco
                    setAlert({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlert(undefined);
                    }, duracaoAlert);
                    // alert(result.message);
                    navigate('/tipo');
                } else {
                    setNome(result.nomeTipo);
                    formRef.current?.setData(result);

                    setDestino(result.temporalidade?.eliminacao ?? false);
                    setIdTemp(result.temporalidade?.idTemp ?? 0);

                    if(result.temporalidade !== null)
                    {
                        setControlTemp(true);
                    }
                    else
                    {
                        setControlTemp(false)
                    }
                }
            });
        }

    }, [editarOuNovo, idTipo]);

    const [idTemp, setIdTemp] = useState<number>();

    const limparCampos = () => {
        formRef.current?.setData({
            nomeTipo: ''
        });
        setIndicesSelecionados([]);
    };

    //--------------------------------------------------------------------------------------------------------------------------------------------------------------
    const [indices, setIndices] = useState<IIndice[]>([]);
    const [indicesDisponiveis, setIndicesDisponiveis] = useState<IIndice[]>([]);
    const [rows, setRows] = useState<IIndice[]>([]);
    const [selectedRows, setSelectedRows] = useState<ITipo_Indice[]>([]);
    const dataFetchedRef = useRef(false);

    const filtrar = (valor: String) => {
        var pesquisa = valor.toLowerCase();
        pesquisa = removerSpecials(pesquisa);
        // Cria cópia da lista
        var listaAtualizada = [...indicesDisponiveis];
        // Inclui todos os elementos que tem pesquisa
        listaAtualizada = listaAtualizada.filter((indice) => {
            var nomeIndice = removerSpecials(indice.nomeIndice.toLowerCase());
            return nomeIndice.toLowerCase().indexOf(pesquisa) !== -1;
        });

        return listaAtualizada;
    }

    function removerSpecials(texto: String) {
        // eliminando acentuação
        texto = texto.replace(/[ÀÁÂÃÄÅ]/, "A");
        texto = texto.replace(/[àáâãäå]/, "a");
        texto = texto.replace(/[ÈÉÊË]/, "E");
        texto = texto.replace(/[Ç]/, "C");
        texto = texto.replace(/[ç]/, "c");

        return texto.replace(/[^a-z0-9]/gi, '');
    }

    useEffect(() => {
        if (dataFetchedRef.current) return;// se ja tiver pego os dados volta(previnir que renderize mais de uma vez)
        dataFetchedRef.current = true;
        setIsLoadingIndice(true);

        Tipo_Indice_Service.list().then((result) => {

            if (result instanceof Error) {//verificar se deu erro
                setIsLoadingIndice(false);
                setAlert({ tipoAlert: "erro", mensagem: result.message });
                setTimeout(() => {
                    setAlert(undefined);
                }, duracaoAlert);
                // alert(result.message);
            }
            else {
                setIndices(result);
            }
        });
        if (editar) {
            Tipo_Indice_Service.getByIdTipo(Number(idTipo)).then((result) => {

                if (result instanceof Error) {//verificar se deu erro
                    carregarIndices();
                }
                else {
                    setIsLoadingIndice(false);
                    setSelectedRows(result);
                }
            });
        }
    }, []);

    const carregarIndices = () => {
        setRows([]);
        var aux = indices;
        selectedRows.forEach(selectedRow => {
            indices.forEach((row, index) => {
                if (row.idIndice === selectedRow.idIndice) {
                    setIndicesSelecionados((prevIndices) => [...prevIndices, { idIndice: row.idIndice, nomeIndice: row.nomeIndice, idComponente: row.idComponente, opcoes: selectedRow.opcoes, indice_de_caixa: selectedRow.indice_de_caixa, data_criacao: selectedRow.data_criacao, exclusivo : selectedRow.exclusivo }]);// adiciona na tabela
                    delete aux[index]
                }
            });
        });
        aux = aux.filter(function (i) {
            return i;
        });
        setRows(aux);
        setIndicesDisponiveis(aux);
        setIsLoadingIndice(false);
    }

    useEffect(() => {
        carregarIndices();
    }, [indices, selectedRows]);


    const [openDialog, setOpenDialog] = useState(false);
    const [openDialogOpcoes, setOpenDialogOpcoes] = useState(false);
    const [isLoadingIndice, setIsLoadingIndice] = useState(false);

    const handleClickOpen = () => {
        setOpenDialog(true);
    };

    const handleClose = () => {
        setOpenDialog(false);
    };

    const [opcoes, setOpcoes] = useState(["", "",]);
    //@ts-expect-error
    const removeOpcao = useCallback((index) => (event) => {
        setOpcoes((opcoes) => {
            const newOpcoes = [...opcoes];
            if (opcoes.length > 2) {
                newOpcoes.splice(index, 1);
            }
            return newOpcoes;
        });
    }, []);
    const addOpcao = useCallback(
        () => setOpcoes((opcoes) => [...opcoes, ""]),
        []
    );

    const [idIndiceSelecionado, setIdIndiceSelecionado] = useState(0);

    const handleClickOpenOpcoes = (idIndice: number, idComponente: number, op: string | undefined) => {
        setOpenDialogOpcoes(true);
        setIdIndiceSelecionado(idIndice);
        setComponente(idComponente);

        if (idComponente == 1) {
            setMascara(op ? op : "");
        } else {

            if (!!op) {
                setOpcoes(op.split("^ "));
            } else {
                setOpcoes(["", ""]);
            }
        }

    };

    const handleCloseOpcoes = () => {
        setOpenDialogOpcoes(false);
    };

    const handleConfirmarMascara = () => {
        indicesSelecionados.forEach(indice => {// passa por cada item 
            if (indice.idIndice === idIndiceSelecionado) {
                indice.opcoes = mascara;
            }
        });
        handleCloseOpcoes();
    }

    const handleConfirmarOpcoes = () => {
        indicesSelecionados.forEach(indice => {// passa por cada item 
            if (indice.idIndice === idIndiceSelecionado) {
                var op = "";
                opcoes.forEach((opcao, index) => {
                    op += opcao// adiciona o item do array
                    if (index !== opcoes.length - 1) {// se não for a ultima posição adiciona uma vírgula
                        op += "^ ";
                    }
                });
                indice.opcoes = op;
            }
        });
        handleCloseOpcoes();
    }

    type Indice = {
        idIndice: number;
        nomeIndice: string;
        idComponente: number;
        opcoes?: string;
        indice_de_caixa?: boolean;
        exclusivo?: boolean;
        data_criacao?: boolean;
    }

    const [indicesSelecionados, setIndicesSelecionados] = useState<Indice[]>([]);

    const handleToggle = (value: Indice) => () => {
        if (!!indicesSelecionados) {

            const currentIndex = indicesSelecionados.indexOf(value);
            const newChecked = [...indicesSelecionados];

            if (currentIndex === -1) {
                newChecked.push(value);
            } else {
                newChecked.splice(currentIndex, 1);
            }

            setIndicesSelecionados(newChecked);
        }
    };
    //--------------------------------------------------------------------------------------------------------------------------------------------------------------


    //@ts-expect-error
    const handleSave = (dados) => {
        if (indicesSelecionados.length === 0) {
            setAlert({ tipoAlert: "aviso", mensagem: "É obrigatório ao menos um índice" });
            setTimeout(() => {
                setAlert(undefined);
            }, duracaoAlert);
        }

        formValidationSchema.validate(dados, { abortEarly: false }).then(() => {

            if (indicesSelecionados.length !== 0) {
                if (editar) {

                    dados.idTipo = Number(idTipo);

                    setIsLoading(true);
                    if (dados.nomeTipo !== nome) {
                        TipoService.updateById(dados).then((result) => {
                            if (result instanceof Error) {
                                setIsLoading(false);
                                setAlert({ tipoAlert: "erro", mensagem: result.message });
                                setTimeout(() => {
                                    setAlert(undefined);
                                }, duracaoAlert);
                            } else {
                                setNome(dados.nomeTipo);
                            }
                        });
                    }

                    var dadosTipo_IndiceUpdate: Array<ITipo_Indice> = [];
                    var dadosTipo_IndiceCreate: Array<ITipo_Indice> = [];

                    indicesSelecionados.forEach((indice, index) => {
                        if (indice.opcoes === undefined) {
                            indice.opcoes = "";
                        }
                        if (!!selectedRows[index]) {
                            dadosTipo_IndiceUpdate.push({
                                idTipo: Number(idTipo),
                                idIndice: indice.idIndice,
                                opcoes: indice.opcoes,
                                indice_de_caixa: !!indice.indice_de_caixa,
                                exclusivo: indice.exclusivo,
                            });
                        } else {
                            dadosTipo_IndiceCreate.push({
                                idTipo: Number(idTipo),
                                idIndice: indice.idIndice,
                                opcoes: indice.opcoes,
                                indice_de_caixa: !!indice.indice_de_caixa,
                                exclusivo: indice.exclusivo,
                            });
                        }
                    });

                    Tipo_Indice_Service.update(dadosTipo_IndiceUpdate).then((result) => {

                        if (result instanceof Error) {
                            setIsLoading(false);
                            setAlert({ tipoAlert: "erro", mensagem: result.message });
                            setTimeout(() => {
                                setAlert(undefined);
                            }, duracaoAlert);
                        }

                    });
                    
                    if(controlTemp)
                    {

                        var temp: ITemp = {
                            idTemp: idTemp ?? 0,
                            codigo: dados.temporalidade.codigo,
                            corrente: dados.temporalidade.corrente, 
                            intermediaria: dados.temporalidade.intermediaria, 
                            eliminacao: destino, 
                            obs: dados.temporalidade.obs 
                        };
                        
                        TipoService.updateTemp(temp).then((result) => {
                        if (result instanceof Error) {
                            setIsLoading(false);
                            setAlert({ tipoAlert: "erro", mensagem: result.message });
                            setTimeout(() => {
                                setAlert(undefined);
                            }, duracaoAlert);
                        }
                        })
                    }
                    
                    if (indicesSelecionados.length > selectedRows.length) {
                        Tipo_Indice_Service.create(dadosTipo_IndiceCreate).then((result) => {

                            setIsLoading(false);
                            if (result instanceof Error) {
                                setAlert({ tipoAlert: "erro", mensagem: result.message });
                                setTimeout(() => {
                                    setAlert(undefined);
                                }, duracaoAlert);
                            }
                            else
                            {
                                setAlert({ tipoAlert: "sucesso", mensagem: "Tipo atualizado" });
                                setTimeout(() => {
                                    setAlert(undefined);
                                }, duracaoAlert);
                                setIsLoading(false);
                            }

                        })
                    } else {

                        setAlert({ tipoAlert: "sucesso", mensagem: "Tipo atualizado" });
                        setTimeout(() => {
                            setAlert(undefined);
                        }, duracaoAlert);
                        setIsLoading(false);

                        if (isSaveAndReturn()) {
                            navigate('/tipo')
                        }

                    }
                }
                if (novo) {
                    setIsLoading(true);

                    if (idTipo == '0') {
                        dados.idTipoPai = null
                    } else {
                        dados.idTipoPai = Number(idTipo);
                    }

                    dados.nivel = nivel;
                    dados.idSetor = Number(idSetor);

                    TipoService.create(dados).then((result) => {
                        if (result instanceof Error) {

                            setIsLoading(false);
                            setAlert({ tipoAlert: "erro", mensagem: result.message });
                            setTimeout(() => {
                                setAlert(undefined);
                            }, duracaoAlert);

                        } else {
                            var dadosTipo_Indice: Array<ITipo_Indice> = []

                            indicesSelecionados.forEach((indice, index) => {

                                if (indice.opcoes === undefined) {
                                    indice.opcoes = "";
                                }

                                if(linhaSelecionada == index)
                                {
                                    dadosTipo_Indice.push({
                                        idTipo: result,
                                        idIndice: indice.idIndice,
                                        opcoes: indice.opcoes,
                                        indice_de_caixa: !!indice.indice_de_caixa,
                                        data_criacao: true,
                                        exclusivo: indice.exclusivo
                                    });    
                                }
                                else
                                {
                                    dadosTipo_Indice.push({
                                        idTipo: result,
                                        idIndice: indice.idIndice,
                                        opcoes: indice.opcoes,
                                        indice_de_caixa: !!indice.indice_de_caixa,
                                        data_criacao: false,
                                        exclusivo: indice.exclusivo
                                    });
                                }

                            });

                            Tipo_Indice_Service.create(dadosTipo_Indice).then((result) => {
                                // setIsLoading(false);
                                if (result instanceof Error) {

                                    setAlert({ tipoAlert: "erro", mensagem: result.message });
                                    setTimeout(() => {
                                        setAlert(undefined);
                                    }, duracaoAlert);

                                } else {
                                    
                                    if(controlTemp)
                                    {

                                    var temp: ITemp = {
                                        idTemp: 0,
                                        codigo: dados.temporalidade.codigo,
                                        corrente: dados.temporalidade.corrente, 
                                        intermediaria: dados.temporalidade.intermediaria, 
                                        eliminacao: destino, 
                                        obs: dados.temporalidade.obs 
                                    };
                                        TipoService.createTemp(temp, dadosTipo_Indice[0].idTipo).then((result) => {
                                            setIsLoading(false);
                                            if (result instanceof Error) {
                                                
                                            setAlert({ tipoAlert: "erro", mensagem: result.message });
                                            setTimeout(() => {
                                                setAlert(undefined);
                                            }, duracaoAlert);
                                            
                                        } else {
                                            setIsLoading(false);
                                            setAlert({ tipoAlert: "sucesso", mensagem: "Tipo cadastrado" });
                                            setTimeout(() => {
                                                setAlert(undefined);
                                            }, duracaoAlert);
                                            
                                            if (isSaveAndReturn()) {
                                                navigate("/tipo")
                                            } else {
                                                limparCampos();
                                            }
                                        }
                                    })
                                    }
                                    else
                                    {
                                        setIsLoading(false);
                                        setAlert({ tipoAlert: "sucesso", mensagem: "Tipo cadastrado" });
                                        setTimeout(() => {
                                            setAlert(undefined);
                                        }, duracaoAlert);
                                    }
                                }
                            });
                        }
                    });
                }
            }
        }).catch((errors: yup.ValidationError) => {

            const validationErrors: { [key: string]: string } = {};

            errors.inner.forEach(error => {
                if (!error.path) return;

                validationErrors[error.path] = error.message;
            });

            formRef.current?.setErrors(validationErrors);

        });
    }

    const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(() => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: theme.palette.background.paper,
            color: themeName === "light" ? 'rgba(0, 0, 0, 0.87)' : 'rgba(255, 255, 255, 0.8)',
            maxWidth: 220,
            border: '1px solid #dadde9',
        },
    }));
    
    const [dataCriacao, setDataCriacao] = useState(Array(indicesSelecionados.length).fill(false));
    const [linhaSelecionada, setLinhaSelecionada] = useState<number>();

    const handleClickRadio = (index: number) => {
        setLinhaSelecionada(index);
        // Atualizar o estado dataCriacao com base na linha selecionada
        setDataCriacao((prevData) => prevData.map((_, i) => i === index));
    };

    useEffect(() => { setLinhaSelecionada(undefined); },[indicesSelecionados])
    
    const [controlTemp, setControlTemp] = useState<boolean>();
    
    const handleClickTemp = () =>
    {
        setControlTemp(!controlTemp);
        setLinhaSelecionada(undefined);
    }

    const [destino, setDestino] = useState<boolean>(false) 

    return (
        <LayoutBaseDePagina
            titulo={novo ? "Novo Tipo" : nome}
            barraDeFerramentas={
                <FerramentaDeDetalhe
                    mostrarBotaoApagar={editar}
                    mostrarBotaoNovo={false}
                    mostrarBotaoSalvarEVoltar

                    mostrarBotaoApagarCarregando={editar && isLoading}
                    mostrarBotaoSalvarCarregando={isLoading}
                    mostrarBotaoSalvarEVoltarCarregando={isLoading}

                    aoClicarEmVoltar={() => navigate('/tipo')}
                    aoClicarEmSalvar={save}
                    aoClicarEmSalvarEVoltar={saveAndReturn}
                />
            }
        >
            {alert !== undefined && (
                <>
                    {alert.tipoAlert === "sucesso" && (
                        <AlertSnackBar gravidade="success" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                    {alert.tipoAlert === "erro" && (
                        <AlertSnackBar gravidade="error" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                    {alert.tipoAlert === "aviso" && (
                        <AlertSnackBar gravidade="warning" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                </>
            )}

            {isLoading && (
                <LinearProgress variant="indeterminate" />
            )}
            <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                <VForm ref={formRef} onSubmit={handleSave}>
                    <Grid container direction="column" padding={2} spacing={2}>
                        {novo && idTipo !== '0' && (
                            <Grid container item direction="row" spacing={2}>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Typography> Este tipo será filho de: <b>{nomeTipo}</b> </Typography>
                                </Grid>

                            </Grid>
                        )}
                        <Grid container item direction="column" spacing={2}>
                            <Grid container item direction="row" spacing={2} >
                                <Grid item xs={12} sm={12} md={4}>
                                    <VTextField fullWidth label="Nome" placeholder="Digite o nome..." name="nomeTipo" disabled={isLoading} />
                                </Grid>
                            </Grid>

                             <Grid container item direction="row" spacing={2} >
                                <Grid item xs={12} sm={12} md={4}>
                                <FormGroup>
                                    <FormControlLabel  control={<Switch disabled={isLoading}  onClick={_ => handleClickTemp()} checked={controlTemp}/>} label="Controlar temporalidade" />
                                    {/* <VSwitch label="Controlar temporalidade" name="temp" disabled={isLoading} onClick={_ => handleClickTemp()} checked={controlTemp}/> */}
                                </FormGroup>
                                </Grid>
                            </Grid>

                            {controlTemp &&
                                 <>
                                    <Grid container item direction="row" spacing={2} >
                                        <Grid item xs={6} sm={6} md={2}>
                                            <VTextField fullWidth label="Código" placeholder="Digite o número que representa o código..." name="temporalidade.codigo" disabled={isLoading}  type="number" />
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={2}>
                                            <FormControl key={"FormControl-Destinacao"}>
                                                <FormLabel key={"FormLabelDestinacao"} >Destinação</FormLabel>
                                                    <RadioGroup
                                                        key = "RadioGroupDestino"
                                                    >
                                                        <FormControlLabel key={"eliminacao"} value={"true"} control={<Radio disabled={isLoading} checked={destino}/>} label="Eliminação" onChange={(_) => { setDestino(true) }} />
                                                        <FormControlLabel key={"guarda"} value={"false"} control={<Radio disabled={isLoading}  checked={!destino}/>} label="Guarda permanente" onChange={(_) => { setDestino(false) }} />
                                                    </RadioGroup>
                                            </FormControl>
                                        </Grid>
                                    </Grid>

                                    <Grid container item direction="row" spacing={2} >
                                        <Grid item xs={6} sm={6} md={2}>
                                            <VTextField fullWidth label="Fase corrente (em anos)" placeholder="Digite o número de anos..." name="temporalidade.corrente" disabled={isLoading} type="number" />
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={2}>
                                            <VTextField fullWidth label="Fase intermediária (em anos)" placeholder="Digite o número de anos..." name="temporalidade.intermediaria" disabled={isLoading}  type="number" />
                                        </Grid>
                                    </Grid>

                                    <Grid container item direction="row" spacing={2} >
                                        <Grid item xs={12} sm={12} md={4}>
                                            <TextField fullWidth label="Observações" placeholder="Digite as observações..." name="temporalidade.obs" disabled={isLoading}></TextField>
                                        </Grid>
                                    </Grid>
                                </>
                            }
                        </Grid>

                    </Grid>

                    <Button sx={{ m: 2 }} variant="contained" onClick={handleClickOpen} disabled={isLoadingIndice || indicesDisponiveis.length === 0} endIcon={isLoadingIndice ? <CircularProgress variant='indeterminate' color='inherit' size={20} /> : undefined}> Selecionar Índices </Button>
                    <Button sx={{ m: 2 }} variant="contained" onClick={() => navigate('/indice/detalhe/novo')}> Novo Indice</Button>

                    <Dialog
                        open={openDialog}
                        onClose={handleClose}
                    >
                        <DialogTitle id="scroll-dialog-title"> Índices </DialogTitle>
                        <DialogContent dividers>
                            {isLoadingIndice ? (
                                <Box display="flex" justifyContent="center" alignItems="center">
                                    <CircularProgress />
                                </Box>
                            ) : (
                                <>
                                    <TextField fullWidth size="small" label="Filtrar" placeholder="Filtrar" autoComplete='off'
                                        onChange={(event) => {
                                            var filtroIndice = event.target.value;
                                            if (filtroIndice === "") {
                                                setRows(indices);
                                            } else {
                                                setRows(filtrar(filtroIndice));
                                            }
                                        }}
                                    />
                                    {rows.length === 0 ? (
                                        <Table sx={{ mt: 2, textAlign: 'center' }}>
                                            <caption> Nenhum índice encontrado </caption>
                                        </Table>
                                    ) : (
                                        <List sx={{ width: '100%', minWidth: 200, bgcolor: 'background.paper' }}>
                                            {!isLoadingIndice && rows.map((value) => {
                                                const labelId = `checkbox-list-label-${value.idIndice}`;

                                                return (
                                                    <ListItem
                                                        key={value.idIndice}
                                                        disablePadding
                                                    >
                                                        <ListItemButton role={undefined} onClick={handleToggle(value)} dense>
                                                            <ListItemIcon>
                                                                <Checkbox
                                                                    edge="start"
                                                                    checked={indicesSelecionados.indexOf(value) !== -1}
                                                                    tabIndex={-1}
                                                                    disableRipple
                                                                />
                                                            </ListItemIcon>
                                                            <ListItemText id={labelId} primary={value.nomeIndice} />
                                                        </ListItemButton>
                                                    </ListItem>
                                                );
                                            })}
                                        </List>
                                    )}
                                </>
                            )}
                        </DialogContent>
                        <DialogActions>
                            <Box
                                width="100%"
                                marginX={1}
                                padding={1}
                                paddingX={2}
                                display="flex"
                                justifyContent="center"
                            >
                                <Button variant="contained" startIcon={<Icon>check</Icon>} onClick={handleClose}> Confirmar </Button>
                            </Box>
                        </DialogActions>
                    </Dialog>

                    <Typography sx={{ m: 2 }} variant="h4"> Índices </Typography>
                    <TableContainer component={Paper} variant="outlined" sx={{ m: 2, width: 'auto' }}>
                        <Table>
                            <TableHead>
                                <TableRow>

                                    <TableCell> Nome </TableCell>
                                    <TableCell> Tipo do componente </TableCell>
                                    <TableCell> Opções </TableCell>
                                    <TableCell align="center"> Editar opções </TableCell>
                                    <TableCell align="center"> Indice exclusivo </TableCell>
                                    <TableCell align="center"> Indice de caixa </TableCell>
                                    {controlTemp &&
                                        <TableCell align="center"> Data de criação </TableCell>
                                    }
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                
                                {indicesSelecionados.map((indice, index) => (
                                    <TableRow key={indice.idIndice}>
                                        <TableCell> {indice.nomeIndice} </TableCell>
                                        <TableCell>
                                            {indice.idComponente == 1 && ("Texto")}
                                            {indice.idComponente == 2 && ("Radio")}
                                            {indice.idComponente == 3 && ("Select")}
                                            {indice.idComponente == 4 && ("Marcar")}
                                            {indice.idComponente == 5 && ("Data")}
                                            {indice.idComponente == 6 && ("Período")}
                                            {indice.idComponente == 7 && ("Numérico")}
                                            {indice.idComponente == 8 && ("Intervalo Numérico")}
                                            {indice.idComponente == 9 && ("Intervalo Alfabético")}
                                            {indice.idComponente == 10 && ("CPF")}
                                            {indice.idComponente == 11 && ("CNPJ")}
                                        </TableCell>
                                        <TableCell size="small">
                                            {(indice.idComponente === 1  || indice.idComponente === 2 || indice.idComponente === 3 || indice.idComponente === 4) && 
                                                (<Typography noWrap> {indice.opcoes?.replaceAll('^', ',')} </Typography>)
                                            }
                                            {(indice.idComponente === 5 || indice.idComponente === 6 || indice.idComponente === 7 || indice.idComponente === 8) &&
                                                ("Este componente não aceita opções")
                                            }

                                            {indice.idComponente === 10 && (<Typography noWrap> 999.999.999-99 </Typography>)}

                                            {indice.idComponente === 11 && (<Typography noWrap> 99.999.999/9999-99 </Typography>)}

                                        </TableCell>
                                        <TableCell align="center">
                                            {(indice.idComponente === 1  || indice.idComponente === 2 || indice.idComponente === 3 || indice.idComponente === 4) && (
                                                <IconButton size="small" onClick={() => handleClickOpenOpcoes(indice.idIndice, indice.idComponente, indice.opcoes)}><Icon> edit </Icon></IconButton>
                                            )}
                                        </TableCell>

                                        <TableCell size="small" align="center">
                                            <Checkbox
                                                checked={indice.exclusivo}
                                                onChange={(event) => {

                                                    setIndicesSelecionados((prevIndices) => {
                                                        const newValue = [...prevIndices];
                                                        newValue.map((value) => {
                                                            if (value.idIndice === indice.idIndice) {
                                                                value.exclusivo = event.target.checked;
                                                            }
                                                        })
                                                        return newValue;
                                                    })

                                                }}
                                            />
                                        </TableCell>

                                        <TableCell size="small" align="center">
                                            <Checkbox
                                                checked={indice.indice_de_caixa}
                                                onChange={(event) => {

                                                    setIndicesSelecionados((prevIndices) => {
                                                        const newValue = [...prevIndices];
                                                        newValue.map((value) => {
                                                            if (value.idIndice === indice.idIndice) {
                                                                value.indice_de_caixa = event.target.checked;
                                                            }
                                                        })
                                                        return newValue;
                                                    })

                                                }}
                                            />
                                        </TableCell>
                                        {controlTemp && 
                                            <TableCell align="center"> 
                                                <>
                                                    <Radio
                                                        checked={linhaSelecionada === index || indice.data_criacao === true}
                                                        onChange={handleClickRadio.bind(null, index)}
                                                    />
                                                </>
                                            </TableCell>
                                        }
                                    </TableRow>
                                ))}

                            </TableBody>

                            <Dialog
                                open={openDialogOpcoes}
                                onClose={handleCloseOpcoes}
                            >
                                <DialogTitle id="scroll-dialog-title-opções">
                                    {componente !== 1 ? "Opções" : "Máscara"}
                                </DialogTitle>
                                <DialogContent dividers>

                                    <Grid container direction="column" padding={2} spacing={2}>
                                        <Box
                                            width="100%"
                                            marginX={1}
                                            padding={1}
                                            paddingX={2}
                                            display="flex"
                                            flexDirection="column"
                                            gap={1}
                                            justifyContent="center"
                                        >
                                            {componente !== 1 &&
                                                opcoes.map((email, index) => (
                                                    <Grid key={index} item xs={12} marginTop={1}>
                                                        <TextField
                                                            value={email}
                                                            onChange={(event) => {
                                                                if (!event.target.value.includes('^')) {
                                                                    setOpcoes((prevOpcoes) => {
                                                                        const newOpcoes = [...prevOpcoes];
                                                                        newOpcoes[index] = event.target.value;
                                                                        return newOpcoes;
                                                                    });
                                                                }
                                                            }}
                                                            label={`Opção ${index + 1}`}
                                                            placeholder={`Opção ${index + 1}`}
                                                        />
                                                        <IconButton color="error" size="large" onClick={removeOpcao(index)}>
                                                            <Icon>close</Icon>
                                                        </IconButton>
                                                    </Grid>
                                                ))
                                            }
                                            {componente === 1 &&
                                                <Grid key={1} item xs={12} whiteSpace={"nowrap"} display="flex" gap={1} alignItems="center">
                                                    <TextField
                                                        value={mascara}
                                                        onChange={(e) => { setMascara(e.target.value) }}
                                                        label={`Máscara`}
                                                        placeholder={`Ex: (99) 9 9999-9999`}
                                                    />

                                                    <HtmlTooltip placement="right-start" arrow title={
                                                        <React.Fragment>
                                                            <Box textAlign={"justify"} fontSize={14}>
                                                                <p color="inherit"> Determine o formato da máscara que você deseja aplicar ao campo de texto: </p>
                                                                <b> 9 </b> - Para número <br />
                                                                <b> a </b> - Para letras <br />
                                                                <b> * </b> - Para ambos <br />
                                                                <br />
                                                                <Box textAlign={"justify"}> Um exemplo seria a mascara de cpf: 999.999.999-99. Perceba que podem ser usados símbolos fixos como (".", "," e entre outros).</Box>
                                                                <br />
                                                                <Box textAlign={"justify"}> Lembre-se que a máscara é um recurso que permite indicar a sequencia e tipos de caracteres que devem aparecer no campo, </Box>
                                                            </Box>
                                                        </React.Fragment>
                                                    }>
                                                        <Icon color='primary'> help_outline </Icon>
                                                    </HtmlTooltip>
                                                </Grid>
                                            }
                                        </Box>
                                    </Grid>

                                </DialogContent>
                                <DialogActions>
                                    <Box
                                        width="100%"
                                        marginX={1}
                                        padding={1}
                                        paddingX={2}
                                        display="flex"
                                        gap={1}
                                        justifyContent="center"
                                    >
                                        {componente !== 1 ? (
                                            <>
                                                <Button variant="contained" onClick={addOpcao} startIcon={<Icon>add</Icon>}> Mais opções</Button>
                                                <Button variant="contained" startIcon={<Icon>check</Icon>} onClick={handleConfirmarOpcoes}> Confirmar </Button>
                                            </>
                                        ) :
                                            <>
                                                <Button variant="contained" startIcon={<Icon>check</Icon>} onClick={handleConfirmarMascara}> Confirmar </Button>
                                            </>
                                        }
                                    </Box>
                                </DialogActions>
                            </Dialog>

                            {indicesSelecionados.length === 0 && (
                                <caption> Selecione os Índices </caption>
                            )}

                        </Table>
                    </TableContainer>
                </VForm>
            </Box>
        </LayoutBaseDePagina >
    )
}